import React from "react";

export const LocalTransportDetailContext = React.createContext(null);

export const useLocalTransportDetailContext = () => {
  const context = React.useContext(LocalTransportDetailContext);
  if (!context)
    throw new Error("LocalTransport Detail Context not provided!");
  return context;
};